import Axios from "axios";

// const DATA_REFRESH_API_URL = process.env.REACT_APP_DATA_REFRESH_API_URL;

// const axiosInstance = Axios.create({
//   baseURL: DATA_REFRESH_API_URL,
//   headers: {
//     "Content-Type": "application/json",
//     Accept: "application/json",
//     "Access-Control-Allow-Credentials": true,
//   },
// });

// export class DataRefreshHttpService {
//   get = async (url) => await this.request({ method: "get", url });

//   post = async (url, data) => await this.request({ method: "post", url, data });

//   put = async (url, data) => await this.request({ method: "put", url, data });

//   patch = async (url, data) => await this.request({ method: "patch", url, data });

//   delete = async (url, data) => await this.request({ method: "delete", url, data });

//   request = (options) => {
//     return new Promise((resolve, reject) => {
//       axiosInstance
//         .request(options)
//         .then((res) => resolve(res.data))
//         .catch((ex) => reject(ex.response?.data || ex));
//     });
//   };
// }

// export default new DataRefreshHttpService();


const DATA_REFRESH_API_URL = process.env.REACT_APP_DATA_REFRESH_API_URL;

export class HttpDRService {
  _axios = Axios.create({
    baseURL: DATA_REFRESH_API_URL
  });

  addRequestInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.request.use(onFulfilled, onRejected);
  };

  addResponseInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.response.use(onFulfilled, onRejected);
  };

  get = async (url) => await this.request(this.getOptionsConfig("get", url));

  post = async (url, data) => await this.request(this.getOptionsConfig("post", url, data));

  put = async (url, data) => await this.request(this.getOptionsConfig("put", url, data));

  patch = async (url, data) => await this.request(this.getOptionsConfig("patch", url, data));

  delete = async (url, data) => await this.request(this.getOptionsConfig("delete", url, data));

  getOptionsConfig = (method, url, data) => {
    return {
      method,
      url,
      data,
      headers: { "Content-Type": "application/vnd.api+json", "Accept": "application/vnd.api+json", 'Access-Control-Allow-Credentials': true },
    };
  };

  request(options) {
    return new Promise((resolve, reject) => {
      this._axios
        .request(options)
        .then((res) => resolve(res.data))
        .catch((ex) => {
          // 🛡️ Safe error handling for missing response (e.g. Network Error)
          const errorPayload = ex.response?.data || { message: ex.message || "Network Error" };
          reject(errorPayload);
        });
    });
  }
}

export default new HttpDRService();
